import { Component, ErrorInfo, FC, ReactNode } from 'react';

import { addError } from '../../utils/datadog';

interface ErrorBoundaryProps {
	fallback: FC<{ error?: Error } | Record<string, unknown>>;
	children?: ReactNode;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, { hasError: boolean; error?: Error }> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false, error: undefined };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		addError(error);
	}

	static getDerivedStateFromError(error: Error) {
		return { hasError: true, error };
	}

	render() {
		return this.state.hasError ? <this.props.fallback error={this.state.error} /> : this.props.children;
	}
}
